// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"3615aab3","116":"5f3be6c4","568":"b150faa0"}[chunkId] + ".js";
};